module.exports = __webpack_public_path__ + "img/bg.750adcf1.gif";